import NumberFieldController from "confinus_ui/forms/number_field_controller";

export default class PriceModifierController extends NumberFieldController {
  public static targets = NumberFieldController.targets.concat([
    "priceModifierType",
    "priceModifierAmount",
  ]);

  public static values = {
    ...NumberFieldController.values,
    leadingTextFixed: { type: String, default: null },
    trailingTextFixed: { type: String, default: null },
  };

  declare private readonly priceModifierTypeTarget: HTMLInputElement;
  declare protected readonly hasPriceModifierTypeTarget: boolean;
  declare private readonly leadingTextFixedValue?: string;
  declare private readonly trailingTextFixedValue?: string;

  public onInitialize() {
    this.handlePriceModifierTypeChanges();

    return super.onInitialize();
  }

  public handlePriceModifierTypeChanges() {
    if (!this.hasPriceModifierTypeTarget) return;

    const type = this.priceModifierTypeTarget.value as
      | "fixed"
      | "percentage"
      | undefined;

    if (type === "fixed") {
      this.update(this.leadingTextAddOnTarget, this.leadingTextFixedValue);
      this.update(this.trailingTextAddOnTarget, this.trailingTextFixedValue);
    } else if (type === "percentage") {
      this.update(this.leadingTextAddOnTarget, "");
      this.update(this.trailingTextAddOnTarget, "%");
    }
  }

  private update(target: HTMLElement | null, text: string | undefined) {
    if (target) {
      target.textContent = text || "";
    }
  }
}
